import { render } from "./IndustrialClientsView.vue?vue&type=template&id=25dcdcef"
import script from "./IndustrialClientsView.vue?vue&type=script&lang=js"
export * from "./IndustrialClientsView.vue?vue&type=script&lang=js"

import "./IndustrialClientsView.vue?vue&type=style&index=0&id=25dcdcef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__